import buttonLoadingAnimation from "../../images/animations/LoadingButton.gif";

interface Props {
	text: string;
}
export function ButtonTextLoadingAnimation(props: Props) {
	return (
		<div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
			{props.text}{" "}
			<img
				className="button-loading-animation"
				src={buttonLoadingAnimation}
				alt="Loading animation"
			></img>
		</div>
	);
}
